import React from "react";
import OrganizationMain from "../../components/organization/OrganizationMain";
import TitleBar from "../../components/navbar/TitleBar";
import NavMenu from "../../components/navbar/NavMenu";
import Footer from "../../components/common/Footer";
import SchoolBusNavMenu from "../../components/createForm/SchoolBusNavMenu";
import { Box } from "@mui/material";

export default function OrganizationPage() {
  const selectedApp = localStorage.getItem("selectedApp");

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        minHeight: "100vh",
      }}
    >
      <Box>
        <TitleBar />
        {selectedApp === "schoolTrack" ? <SchoolBusNavMenu /> : <NavMenu />}
        <OrganizationMain starting={false} />
      </Box>
      <Footer />
    </Box>
  );
}
